import { FieldTextarea } from '@dixa/lib-shared-habla';
import { Field } from 'redux-form';

export function GcmControls(): JSX.Element {
  return (
    <Field
      component={FieldTextarea}
      label="API key"
      name="platformCredential"
      placeholder="Google API key"
      required
      type="text"
    />
  );
}
